import PonudjeniOdgovor from "./PonudjeniOdgovor";
import "./Pitanje.css";
import { Input } from "antd";
const { TextArea } = Input;

const Pitanje = ({ pitanje }) => {
  return (
    <div className="pitanje-card">
      <h4 className="tekst-pitanja">
        <span className="obavezno-zvezdica">
          {pitanje.obavezno ? "*" : "\u00A0"}
        </span>
        <span className="tekst-broj">{pitanje.pozicija}.</span>
        <span className="tekst-tekst">{pitanje.tekstPitanja}</span>
      </h4>

      {pitanje.objasnjenje && (
        <h5 className="pitanje-objasnjenje">{pitanje.objasnjenje}</h5>
      )}

      {pitanje.tip === "TEKSTUALNO" ? (
        <TextArea
          type="text"
          placeholder="Unesite odgovor"
          className="pitanje-input"
        />
      ) : (
        <div className="odgovori-lista">
          {pitanje.ponudjeniOdgovori
            .sort((a, b) => a.pozicija - b.pozicija)
            .map((odg) => (
              <PonudjeniOdgovor key={odg.id} odgovor={odg} tip={pitanje.tip} />
            ))}
        </div>
      )}
    </div>
  );
};

export default Pitanje;
